( function () {
  const menu = document.querySelector( '#mega-menu-primary_menu' );
  if ( !menu ) return;

  const hideTimers = new WeakMap();
  const HIDE_DELAY = 200; // ms grace period for cursor travel between tab and dropdown

  function snapHide( sub ) {
    if ( !sub ) return;
    const existing = hideTimers.get( sub );
    if ( existing ) clearTimeout( existing );
    const t = setTimeout( function () {
      hideTimers.delete( sub );
      sub.style.opacity = '0';
    }, HIDE_DELAY );
    hideTimers.set( sub, t );
  }

  function releaseHide( sub ) {
    if ( !sub ) return;
    const existing = hideTimers.get( sub );
    if ( existing ) {
      clearTimeout( existing );
      hideTimers.delete( sub );
    }
    sub.style.removeProperty( 'opacity' );
  }

  const observer = new MutationObserver( function ( mutations ) {
    mutations.forEach( function ( mutation ) {
      const el = mutation.target;
      const old = mutation.oldValue || '';

      if ( el === menu ) {
        if ( old.includes( 'mega-menu-hover' ) && !el.classList.contains( 'mega-menu-hover' ) ) {
          el.querySelectorAll( ':scope > li > .mega-sub-menu' ).forEach( snapHide );
        }
      } else {
        const sub = el.querySelector( ':scope > .mega-sub-menu' );
        if ( !old.includes( 'mega-toggle-on' ) && el.classList.contains( 'mega-toggle-on' ) ) {
          releaseHide( sub );
        } else if ( old.includes( 'mega-toggle-on' ) && !el.classList.contains( 'mega-toggle-on' ) ) {
          snapHide( sub );
        }
      }
    } );
  } );

  function startObserving() {
    observer.observe( menu, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
    } );

    menu.querySelectorAll( ':scope > li' ).forEach( function ( item ) {
      observer.observe( item, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['class'],
      } );
    } );
  }

  function stopObserving() {
    observer.disconnect();
    menu.querySelectorAll( ':scope > li > .mega-sub-menu' ).forEach( releaseHide );
  }

  const mq = window.matchMedia( '(min-width: 768px)' );

  function handleBreakpoint( e ) {
    if ( e.matches ) {
      startObserving();
    } else {
      stopObserving();
    }
  }

  mq.addEventListener( 'change', handleBreakpoint );
  handleBreakpoint( mq );
} )();
